const EMPTY = "";
const SPACE = " ";
const PERIOD = ".";
const COMMA = ",";
const COLON = ":";
const HASH = "#";
const SLASH = "/";
const DASH = "-";
const UNDERSCORE = "_";
const QUESTION_MARK = "?";
const EXCLAMATION_MARK = "!";
const PERCENT = "%";
const PERIOD_WITH_SPACE = `${PERIOD}${SPACE}`;
const COMMA_WITH_SPACE = `${COMMA}${SPACE}`;
const COLON_WITH_SPACE = `${COLON}${SPACE}`;
const VERTICAL_BAR = "|";
const VERTICAL_BAR_WITH_SPACES = `${SPACE}${VERTICAL_BAR}${SPACE}`;
const COPYRIGHT = "©";
const END_OF_LINE = "\n";
const ASTERISK = "*";
const HORIZONTAL_TAB = "\t";
const DOUBLE_QUOTE = '"';
function capitalize(value) {
    return [
        value.at(0)?.toLocaleUpperCase(),
        value.slice(1)
    ].join(EMPTY);
}
function capitalizeStrict(value) {
    return [
        value.at(0)?.toLocaleUpperCase(),
        value.slice(1).toLocaleLowerCase()
    ].join(EMPTY);
}
function uppercase(value) {
    return value.toLocaleUpperCase();
}
function joinWords(values) {
    return values.join(SPACE);
}
function joinLines(values) {
    return values.join(END_OF_LINE);
}
function concat(values) {
    return values.join(EMPTY);
}
export { ASTERISK, capitalize, capitalizeStrict, COLON, COLON_WITH_SPACE, COMMA, COMMA_WITH_SPACE, concat, COPYRIGHT, DASH, DOUBLE_QUOTE, EMPTY, END_OF_LINE, EXCLAMATION_MARK, HASH, HORIZONTAL_TAB, joinLines, joinWords, PERCENT, PERIOD, PERIOD_WITH_SPACE, QUESTION_MARK, SLASH, SPACE, UNDERSCORE, uppercase, VERTICAL_BAR, VERTICAL_BAR_WITH_SPACES };

//# sourceMappingURL=str.js.map